// extracted by mini-css-extract-plugin
export default {"big":"Character_big__2-i43","head":"Character_head__7IwCJ","colomn":"Character_colomn__wcNyB","spaceup":"Character_spaceup__0zlKR"};